export const messages = {
    loading: "Please wait! loading",
    success: "Success! record saved successfully",
    deleteSuccess: "Success! record deleted successfully",
    error: "Error while performing operation!",
    warning: "Notice! unable to perform operation",
}